// extracted by mini-css-extract-plugin
export default {"characterContainer":"Character_characterContainer__vLXLn","characterImage":"Character_characterImage__+aGLl"};